import axios from 'axios';

if (!import.meta.env.VITE_APP_PHOTO_API_URL) {
  throw new Error('ABMI API Env not set: VITE_APP_PHOTO_API_URL');
}

const abmiApiUrl = import.meta.env.VITE_APP_PHOTO_API_URL;

const abmiAxios = axios.create({
  baseURL: abmiApiUrl
});

export async function getAllPhotos (sname, sppGroup) {
  const apiFct = '/get-biobrowser-photos';
  try {
    const response = await abmiAxios.get(apiFct, { params: { sname, sppGroup } });
    const data = response.data;
    return data;
  } catch (error) {
    console.error(error);
  }
  return null;
}

const abmiApi = {
  getAllPhotos
};

export default abmiApi;
